import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { CampaignConfig } from 'schemas/CampaignConfig.schema.ts';
import { apiFetch } from 'utils/apiUtils.ts';

export interface UpdateCampaignResponse {
  Version: number;
}

export default function useUpdateCampaign() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      teamId,
      campaignId,
      campaign,
    }: {
      teamId: string;
      campaignId: string;
      campaign: CampaignConfig;
    }) => apiFetch<UpdateCampaignResponse>({
      path: `team/${teamId}/campaign/${campaignId}`,
      method: 'PUT',
      accessToken: String(tokens.accessToken),
      body: campaign.CampaignConfig,
    }),
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['campaign'] });
    },
  });
}
